var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDishwasher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.54 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dishwasher"
  }, "Dishwasher Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dishwasher"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.89,41.88a.54.54,0,0,1-.36-.14L4.31,35.52a.51.51,0,0,1,0-.71.5.5,0,0,1,.71,0L11.24,41a.51.51,0,0,1,0,.71A.54.54,0,0,1,10.89,41.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86,41.88a.5.5,0,0,1-.35-.14L3.94,39.18a.51.51,0,0,1,0-.71.5.5,0,0,1,.71,0L7.21,41a.5.5,0,0,1-.35.85Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.39,48H1.54V43.56H29.39ZM3,46.49H27.89V45.06H3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31,6.56a.75.75,0,0,1-.75-.75V3.62a.75.75,0,0,1,1.5,0V5.81A.74.74,0,0,1,6.31,6.56Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.53,6.56a.75.75,0,0,1-.75-.75V3.62a.75.75,0,1,1,1.5,0V5.81A.74.74,0,0,1,12.53,6.56Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24,6.56a.74.74,0,0,1-.75-.75V3.62a.75.75,0,1,1,1.5,0V5.81A.75.75,0,0,1,9.24,6.56Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.06,
    cy: 4.71,
    r: 1.65
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.73,0H2.82A2.75,2.75,0,0,0,.07,2.76V42.31a2.75,2.75,0,0,0,2.75,2.75H27.73a2.75,2.75,0,0,0,2.75-2.75V2.76A2.75,2.75,0,0,0,27.73,0ZM2.82,1.51H27.73A1.25,1.25,0,0,1,29,2.76V7.7H1.57V2.76A1.25,1.25,0,0,1,2.82,1.51ZM27.73,43.56H2.82a1.25,1.25,0,0,1-1.25-1.25V9.2H29V42.31A1.25,1.25,0,0,1,27.73,43.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishwasher);
export default __webpack_public_path__ + "static/media/dishwasher.22b3cda762d8f1bf8a26ea4aa52f55ec.svg";
export { ForwardRef as ReactComponent };